import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  Tooltip,
  DatePicker,
  Divider,
  Col,
  Card,
  Table,
  Form,
  Spin,
  Select,
  Collapse,
  Button,
  Statistic,
} from "antd";
import {
  FolderOpenOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";

// PROJECT IMPORTS
import { CSVLink } from "react-csv";
import appStatic from "../../../../../../config/appStatic";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { rightAction } from "../../../../../../redux/actions";
import CustomButton from "../../../../../../components/custom/CustomButton";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const Search = Input;

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const ApplyCharges = (props) => {
  const {
    currentCustomerObj,
    userData,
    rightBtn,
    rightAction,
    transferTypeList,
    toAccountTypeList,
    showSearch,
    setShowSearch,
  } = props;
  const { monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  //   const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [chargeId, setChargeId] = useState(null);
  const [chargesList, setChargesList] = useState([]);
  const [chargesDetails, setChargesDetails] = useState([]);
  const [chargesTableDetails, setChargesTableDetails] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  function selectTableCount(value) {
    setTableCount(value);
  }

  useEffect(() => {
    getChargeDetailById();
    getTemplate();
    console.log(currentCustomerObj);
    // setIsLoading(false);
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      // sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Due as of",
      dataIndex: "dueAsOf",
      // sorter: (a, b) => a.dueAsOf.localeCompare(b.dueAsOf),
    },
    {
      title: "Due",
      dataIndex: "due",
      // sorter: (a, b) => a.due.localeCompare(b.due),
    },
    {
      title: "Paid",
      dataIndex: "paid",
      // sorter: (a, b) => a.paid.localeCompare(b.paid),
    },
    {
      title: "Waived",
      dataIndex: "waived",
      // sorter: (a, b) => a.waived.localeCompare(b.waived),
    },
    {
      title: "Outstanding",
      dataIndex: "outstanding",
      // sorter: (a, b) => a.outstanding.localeCompare(b.outstanding),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <>
          <Tooltip title={`view ${record.name}`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              onClick={() => handleOnView(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        </>
      ),
    },
  ];

  // function handleOnView(record) {
  //   if (!record) {
  //     console.log("No record selected");
  //     return;
  //   }
  //   navigate("/detail-charge", {
  //     state: { ...record, clientDetails: currentCustomerObj },
  //   });
  // }

  function handleOnView(record) {
    if (!record) {
      console.log("No record selected");
      return;
    }
    navigate("/detail-charge", {
      state: { ...currentCustomerObj, recordDetails: record },
    });
  }

  // FLOAT METHODS
  // function handleOnView() {
  //   // console.log(selectedRow);return
  //   delete selectedRow.amount;
  //   selectedRow.amount = selectedRow.amountToUse;
  //   const { detailBtn } = rightBtn;
  //   if (detailBtn.toLowerCase() === "primary") {
  //     navigate("/view-gla0200", { state: selectedRow });
  //   } else {
  //     console.log("Please choose a record from the table to open");
  //   }
  // }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  const getChargeDetailById = () => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}/charges?limit=14&offset=0`;

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        const objList = res.pageItems;
        let tempArray = [];
        console.log(objList);

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            dueAsOf: element?.dueDate
              ? BOM.DateTime(element?.dueDate, "only-date")
              : "-",
            due: element?.amount ? element?.amount : "-",
            paid: element?.amountPaid,
            waived: element?.amountWaived,
            outstanding: element.amountOutstanding
              ? element.amountOutstanding
              : "-",
          });
        });

        setChargesTableDetails(tempArray);

        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });
        setIsLoading(false);
      }
    });
  };

  const getTemplate = () => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}/charges/template`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.chargeOptions;
        let tempArray = [];

        // console.log(objList);
        // return;

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            value: element?.id,
            label: element?.name
              ? `${element?.name} (${element?.currency?.name})`
              : "-",
            clientno: element?.accountNo ? element?.accountNo : "-",
            externalId: element?.externalId ? element?.externalId : "-",
            status: element?.status ? element?.status.value : "-",
            branch: element?.officeName ? element?.officeName : "-",
            staff: element?.staffName ? element?.staffName : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onChangeCharge = (chargeParam) => {
    console.log(chargeParam);
    // return;
    setChargeId(chargeParam);
    getChargeTemplate(chargeParam);
  };

  const getChargeTemplate = (chargeParam) => {
    setIsLoading(true);

    const url = `${apiConfig.charges}/${chargeParam}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempChargeData = [];

        useForm.setFieldsValue({
          amount: objList.amount,
          chargeCalculation: objList?.chargeCalculationType?.value,
          chargeTimeType: objList?.chargeTimeType?.value,
        });

        objList?.productOptions?.forEach((element) => {
          tempChargeData.push({
            value: element.id,
            label: element.name,
            amount: element.amount,
            chargeCalculationType: element.chargeCalculationType,
            chargeTimeType: element.chargeTimeType,
          });
        });

        setChargesDetails(tempChargeData);
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/cst0100", { replace: false });
  }

  const onSubmit = (formValues) => {
    formValues.dueDate = formValues.dueDate
      ? BOM.DateTime(formValues.dueDate, "only-date")
      : formValues.dueDate;

    delete formValues.chargeCalculation;
    delete formValues.chargeTimeType;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      `${apiConfig.Clients}/${currentCustomerObj.id}/charges`,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newChargeMsg);
          getChargeDetailById();
          // navigate("/detail-customer", {
          //   state: { id: res.clientId, branchId: res.officeId },
          // });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate(0);
          setIsLoading(false);
        },
      }
    );
  };

  const [ghost, setGhost] = useState(null);
  const Items = [
    {
      key: "1",
      label: "",
      children: (
        <Form
          style={{ paddingTop: 20, marginBottom: 20 }}
          form={useForm}
          layout="vertical"
          onFinish={onSubmit}
        >
          <Row style={{ justifyContent: "space-betwen" }}>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="chargeId"
                label={<Text strong>{labelConfig.charges}</Text>}
              >
                <Select
                  onChange={onChangeCharge}
                  options={chargesList}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.charges,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="amount"
                label={<Text strong>{labelConfig.amount}</Text>}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="chargeCalculation"
                label={<Text strong>{labelConfig.chargeCalculation}</Text>}
              >
                <Input
                  disabled
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.chargeCalculation
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="chargeTimeType"
                label={<Text strong>{labelConfig.chargeTimeType}</Text>}
              >
                <Input
                  disabled
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.chargeTimeType
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="dueDate"
                label={<Text strong>{labelConfig.dueForCollectionOn}</Text>}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Divider />

            <CustomButton
              content="Submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#3E2336"
              colorText="white"
              hoverBackground="#3E2336"
              onClick={onSubmit}
            />
          </Row>
        </Form>
      ),
    },
  ];

  return (
    <Spin spinning={isLoading} size="large">
      <Collapse
        ghost={ghost}
        items={Items}
        bordered={false}
        expandIconPosition={"end"}
        style={{ padding: "0px", marginBottom: 15, marginTop: 15 }}
        expandIcon={({ isActive }) => {
          {
            isActive ? setGhost(false) : setGhost(true);
          }
          return (
            <>
              {isActive ? (
                <CustomButton
                  content="Close"
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                />
              ) : (
                <CustomButton
                  content="Add Charge"
                  htmlType="submit"
                  backgroundColor="#3E2336"
                  colorText="white"
                  hoverBackground="#3E2336"
                />
              )}
            </>
          );
        }}
      />
      <Table
        columns={columns}
        dataSource={chargesTableDetails}
        bordered
        pagination={{
          position: "bottomCentre",
          pageSize: tableCount,
        }}
      />
    </Spin>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ApplyCharges);
